export enum PageName {
  Profile = 'profile',
  AccountSettings = 'settings',
  Standalone = 'standalone',
  Custom = 'custom',
}
